import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { ChannelApiResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { ReadRequestOptions } from '../requestOptions';

export interface AllowedValueRaw {
  id: number;
  created_at: string | null;
  updated_at: string | null;
  value_set_id: number;
  frontend_value: string;
  channel_value_id: string;
  aliases: string | null;
  laravel_through_key: number;
}

export interface AllowedValue {
  value: string;
  display_value: string;
  channel_value_id: string;
}

export interface AllowedValuesResponse {
  allowed_values: AllowedValue[];
  raw_data?: AllowedValueRaw[];
}

export const getAllowedValues = async (
  scope: RequestScope,
  subscriptionId: number,
  assignmentId: number,
  options: ReadRequestOptions
): Promise<ChannelApiResponse<AllowedValuesResponse>> => {
  try {
    if (!subscriptionId || subscriptionId < 1) {
      throw new Error('Valid subscription ID is required');
    }
    if (!assignmentId || assignmentId < 1) {
      throw new Error('Valid assignment ID is required');
    }

    const result = await scopedChannelApi(scope).get<{ data?: AllowedValueRaw[] }>(`atts/spec_allowed_values/${assignmentId}`, {
      ...options,
      headers: {
        'x-astur-subscription-id': subscriptionId.toString(),
      },
    });

    // Transform the response to our format
    const rawData: AllowedValueRaw[] = result.data?.data || [];
    const allowedValues: AllowedValue[] = rawData.map((item) => ({
      value: item.channel_value_id,
      display_value: item.frontend_value,
      channel_value_id: item.channel_value_id,
    }));

    return {
      data: {
        allowed_values: allowedValues,
        raw_data: rawData,
      },
      status: result.status,
    };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
